import React from 'react'

const DragGroupCollapseBar = (props) => {
    return <div className={`dragGroupCollapseBar ${props.expanded ? 'expanded' : 'collapsed'}`}>
        <label className='switch'>
            <input
                disabled={props.disabled}
                type='checkbox'
                checked={props.expanded}
                onClick={() => {
                    props.toggleGroupCollapseStatus?.(props.groupIndex, props.expanded)
                    props.setExpanded(!props.expanded)
                }}
            />
            <span className='slider round'></span>
        </label>
    </div>
}

export default DragGroupCollapseBar